module.exports = __webpack_public_path__ + "static/img/request-a-demo.4a81e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/request-a-demo.png
// module id = IG4I
// module chunks = 0